"use strict";

// 🚀 Vanilla JS로 완전 재작성 (jQuery 제거)
document.addEventListener('DOMContentLoaded', function() {
	const adpPopup = {
		sPrevious: window.scrollY,
		sDirection: "down",

		/*
		 * Initialize
		 */
		init: function () {
			this.popupInit();
			this.events();
		},

		/*
		 * Events
		 */
		events: function () {
			const self = this;
			
			// Custom Events - Event Delegation 사용
			document.addEventListener("click", function(e) {
				if (e.target.closest(".popup-close")) {
					self.closePopup(e.target.closest(".popup"));
				}
				if (e.target.closest(".popup-accept")) {
					self.acceptPopup(e.target.closest(".popup"));
					self.closePopup(e.target.closest(".popup"));
				}
				if (e.target.closest(".age-verification__popup-close")) {
					self.agePopup(e.target.closest(".popup"));
					self.closePopup(e.target.closest(".popup"));
				}
				if (e.target.closest(".age-verification__button-no")) {
					self.ageDeclined();
				}
			});

			// ESC 키로 팝업 닫기
			document.addEventListener("keyup", function (e) {
				if (e.key === "Escape") {
					document.querySelectorAll('.popup-open[data-esc-close="true"]').forEach(function (popup) {
						self.closePopup(popup);
					});
				}
				if (e.key === "F4") {
					document.querySelectorAll('.popup-open[data-f4-close="true"]').forEach(function (popup) {
						self.closePopup(popup);
					});
				}
			});

			// Overlay 클릭으로 팝업 닫기
			document.addEventListener("click", function (e) {
				if (e.target.classList.contains("popup-overlay")) {
					document.querySelectorAll('.popup-open[data-overlay-close="true"]').forEach(function (popup) {
						self.closePopup(popup);
					});
				}
			});
		},

		/*
		 * Init popup elements
		 */
		popupInit: function () {
			const self = this;
			
			// Set scroll direction
			document.addEventListener("scroll", function () {
				let scrollCurrent = window.scrollY;

				if (scrollCurrent > self.sPrevious) {
					self.sDirection = "down";
				} else {
					self.sDirection = "up";
				}

				self.sPrevious = scrollCurrent;
			});

			// Open popup
			document.querySelectorAll(".popup").forEach(function (popup) {
				// Manual Launch
				if (popup.dataset.openTrigger === "manual") {
					let selector = popup.dataset.openManualSelector;

					if (selector) {
						const triggerElements = document.querySelectorAll(selector);
						triggerElements.forEach(function(el) {
							el.classList.add("popup-trigger");
						});

						document.addEventListener("click", function (e) {
							const target = e.target.closest(selector);
							if (target) {
								e.preventDefault();
								popup.classList.remove("popup-already-opened");
								self.openPopup(popup);

								if (e.target.classList.contains("popup")) {
									self.closePopup(document.querySelector(selector));
								}
							}
						});
					}
				}

				// Checks whether a popup should be displayed or not
				if (!self.isAllowPopup(popup) && !popup.classList.contains("age-verification")) {
					return;
				}

				self.openTriggerPopup(popup);
			});
		},

		/*
		 * Trigger open popup
		 */
		openTriggerPopup: function (popup) {
			const self = this;
			const trigger = popup.dataset.openTrigger;

			// Age Verification
			if (trigger === "none") {
				let ageVerification = self.getCookie("popup-age-" + (popup.dataset.id || 0));
				if (!ageVerification) self.openPopup(popup);
			}

			// Time Delay
			if (trigger === "delay") {
				setTimeout(function () {
					self.openPopup(popup);
				}, popup.dataset.openDelayNumber * 1000);
			}

			// Exit Intent
			if (trigger === "exit") {
				let showExit = true;
				document.addEventListener("mousemove", function (e) {
					let scroll = window.pageYOffset || document.documentElement.scrollTop;
					if (e.pageY - scroll < 7 && showExit) {
						self.openPopup(popup);
						showExit = false;
					}
				});
			}

			// Scroll Position
			if (trigger === "scroll") {
				const pointScrollType = popup.dataset.openScrollType;
				const pointScrollPosition = popup.dataset.openScrollPosition;

				document.addEventListener("scroll", function () {
					// Type px
					if (pointScrollType === "px") {
						if (window.scrollY >= pointScrollPosition) {
							self.openPopup(popup);
						}
					}

					// Type %
					if (pointScrollType === "%") {
						if (self.getScrollPercent() >= pointScrollPosition) {
							self.openPopup(popup);
						}
					}
				});
			}

			// Accept Agreement
			if (trigger === "accept") {
				let accept = self.getCookie("popup-accept-" + (popup.dataset.id || 0));
				if (!accept) {
					self.openPopup(popup);
				}
			}
		},

		/*
		 * Trigger close popup
		 */
		closeTriggerPopup: function (popup) {
			const self = this;
			const trigger = popup.dataset.closeTrigger;

			// Time Delay
			if (trigger === "delay") {
				setTimeout(function () {
					self.closePopup(popup);
				}, popup.dataset.closeDelayNumber * 1000);
			}

			// Scroll Position
			if (trigger === "scroll") {
				const pointScrollType = popup.dataset.closeScrollType;
				const pointScrollPosition = popup.dataset.closeScrollPosition;
				const initScrollPx = popup.dataset.initScrollPx;
				const initScrollPercent = popup.dataset.initScrollPercent;

				document.addEventListener("scroll", function () {
					// Type px
					if (pointScrollType === "px") {
						if (
							self.sDirection === "up" &&
							window.scrollY < initScrollPx - pointScrollPosition
						) {
							self.closePopup(popup);
						}

						if (
							self.sDirection === "down" &&
							window.scrollY >= parseInt(initScrollPx) + parseInt(pointScrollPosition)
						) {
							self.closePopup(popup);
						}
					}

					// Type %
					if (pointScrollType === "%") {
						if (
							self.sDirection === "up" &&
							self.getScrollPercent() < initScrollPercent - pointScrollPosition
						) {
							self.closePopup(popup);
						}

						if (
							self.sDirection === "down" &&
							self.getScrollPercent() >= parseInt(initScrollPercent) + parseInt(pointScrollPosition)
						) {
							self.closePopup(popup);
						}
					}
				});
			}
		},

		/*
		 * Open popup
		 */
		openPopup: function (popup) {
			const self = this;

			// Hide body scroll
			if (popup.dataset.bodyScrollDisable === "true") {
				document.body.classList.add("popup-scroll-hidden");
			}

			// Set Cookie of Limit display
			let limit = parseInt(self.getCookie("popup-" + popup.dataset.id) || 0) + 1;
			self.setCookie("popup-" + popup.dataset.id, limit, {
				expires: popup.dataset.limitLifetime,
			});

			if (popup.classList.contains("popup-open")) {
				return;
			}

			// Check already opened
			if (popup.classList.contains("popup-already-opened")) {
				return;
			}

			// Display popup
			popup.classList.add("popup-open");

			// Set current scroll
			popup.dataset.initScrollPx = window.scrollY;
			popup.dataset.initScrollPercent = self.getScrollPercent();

			// Open animation
			let animation = popup.dataset.openAnimation;
			self.applyAnimation(popup, animation);

			// Init close trigger
			self.closeTriggerPopup(popup);
		},

		/*
		 * Age popup
		 */
		agePopup: function (popup) {
			const self = this;
			// Set Cookie of Age
			self.setCookie("popup-age-" + popup.dataset.id, 1, {
				expires: 360,
			});
		},

		/*
		 * Age declined
		 */
		ageDeclined: function () {
			const question = document.querySelector(".age-verification__question");
			const declined = document.querySelector(".age-verification__declined");
			if (question) question.classList.remove("show");
			if (declined) declined.classList.add("show");
		},

		/*
		 * Accept popup
		 */
		acceptPopup: function (popup) {
			const self = this;
			// Set Cookie of Accept
			self.setCookie("popup-accept-" + popup.dataset.id, 1, {
				expires: 360,
			});
		},

		/*
		 * Close popup
		 */
		closePopup: function (popup) {
			const self = this;

			// Close animation
			let animation = popup.dataset.exitAnimation;

			self.applyAnimation(popup, animation, function () {
				// Already opened
				popup.classList.add("popup-already-opened");

				// Hide popup
				popup.classList.remove("popup-open");

				// Remove classes from body
				document.body.classList.remove("popup-scroll-hidden");
			});
		},

		/*
		 * Checks whether a popup should be displayed or not
		 */
		isAllowPopup: function (popup) {
			const self = this;

			// Has user seen this popup before?
			let limitDisplay = parseInt(popup.dataset.limitDisplay || 0);
			let limitDisplayCookie = parseInt(self.getCookie("popup-" + popup.dataset.id));

			if (limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay) {
				return false;
			}

			return true;
		},

		/*
		 * Apply animation
		 */
		applyAnimation: function (popup, name, callback) {
			const overlayName = callback ? "popupExitFade" : "popupOpenFade";
			const overlay = popup.nextElementSibling;

			// Overlay Animation
			if (overlay && overlay.classList.contains("popup-overlay")) {
				overlay.classList.add("popup-animated", overlayName);
				overlay.addEventListener("animationend", function handler() {
					overlay.classList.remove("popup-animated", overlayName);
					overlay.removeEventListener("animationend", handler);
				}, { once: true });
			}

			// Wrap Animation
			const popupWrap = popup.querySelector(".popup-wrap");
			if (popupWrap) {
				popupWrap.classList.add("popup-animated", name);
				popupWrap.addEventListener("animationend", function handler() {
					popupWrap.classList.remove("popup-animated", name);
					popupWrap.removeEventListener("animationend", handler);
					if (callback) callback();
				}, { once: true });
			}
		},

		/*
		 * Get cookie
		 */
		getCookie: function (name) {
			const matches = document.cookie.match(
				new RegExp(
					"(?:^|; )" +
						name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
						"=([^;]*)"
				)
			);
			return matches ? decodeURIComponent(matches[1]) : undefined;
		},

		/*
		 * Set cookie
		 */
		setCookie: function (name, value, options) {
			options = options || {};
			options.path = options.hasOwnProperty("path") ? options.path : "/";
			options.expires = parseInt(options.expires);

			if (typeof options.expires == "number" && options.expires) {
				options.expires = new Date().setDate(
					new Date().getDate() + options.expires
				);
				options.expires = new Date(options.expires).toUTCString();
			}

			value = encodeURIComponent(value);
			let updatedCookie = name + "=" + value;

			for (let propName in options) {
				updatedCookie += "; " + propName;
				let propValue = options[propName];
				if (propValue !== true) {
					updatedCookie += "=" + propValue;
				}
			}

			document.cookie = updatedCookie;
		},

		/*
		 * Get scroll percent
		 */
		getScrollPercent: function () {
			const h = document.documentElement;
			const b = document.body;
			const st = "scrollTop";
			const sh = "scrollHeight";
			return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
		},
	};

	// Initialize
	adpPopup.init();

	// Shopify section events
	document.addEventListener("shopify:section:load", function () {
		adpPopup.init();
	});

	document.addEventListener("shopify:section:unload", function () {
		document.body.classList.remove("popup-scroll-hidden");
	});
});
